import { CareerId } from '@common/const/catalog/career';
import { ClientType } from '@common/model/client/clientType';
import { DealStatus } from '@common/model/deal';
import { ProcessingAndReviewsFiltersType } from '../ui/processingAndReviews';

export enum TypeOfItems {
  Processing = 1,
  Review = 2,
}

export const DEFAULT_FILTERS_VALUES: ProcessingAndReviewsFiltersType = {
  careerId: CareerId.Nanny,
  clientType: ClientType.Employer,
  dealStatus: DealStatus.Negotiation,
  typeOfItems: TypeOfItems.Processing,
  page: 1,
};

export const PER_PAGE = 100;
